<template>
  <div class="col-1">
    <slot />
  </div>
</template>
